import { RegularButtonWrapper } from '@monthio/react-components'
import styled from 'styled-components'

export const StyledRegularButtonWrapper = styled(RegularButtonWrapper)`
	margin-top: 24px;
`
